import { useMsal } from "@azure/msal-react";

export default function Unauthorized() {
    const { instance } = useMsal();

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    };

    return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
            <div className="text-center bg-white p-10 rounded-lg shadow-md max-w-md w-full">
                <div className="text-red-500 text-6xl mb-4">403</div>
                <h1 className="text-2xl font-bold text-gray-800 mb-2">
                    Access Denied
                </h1>
                <p className="text-gray-600 mb-6">
                    You must be an admin to access the recruitment portal.
                </p>
                <button
                    onClick={handleLogout}
                    className="px-6 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
                >
                    Logout
                </button>
            </div>
        </div>
    );
}